export default "__VITE_ASSET__CaQ$$maO__"